import type { SVGProps } from "react";

export const Sections = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={16}
      height={16}
      {...props}
    >
      <title id="UhZsKF78WCs3iijYo6sEM-title">Sections</title>
      <desc id="UhZsKF78WCs3iijYo6sEM-description">Sections blocks</desc>
      <rect
        width="10.5"
        height="6"
        x="1.5"
        y="1.5"
        fill="currentColor"
        opacity="0.72"
        rx="1"
      ></rect>
      <path
        fill="currentColor"
        d="M14.25 2.5a1 1 0 011-1h6.25a1 1 0 011 1v10.75a1 1 0 01-1 1h-6.25a1 1 0 01-1-1V2.5z"
      ></path>
      <path
        fill="currentColor"
        d="M14.25 17.5a1 1 0 011-1h6.25a1 1 0 011 1v4a1 1 0 01-1 1h-6.25a1 1 0 01-1-1v-4z"
        opacity="0.72"
      ></path>
      <path
        fill="currentColor"
        d="M1.5 10.75a1 1 0 011-1H11a1 1 0 011 1V21.5a1 1 0 01-1 1H2.5a1 1 0 01-1-1V10.75z"
      ></path>
    </svg>
  );
};
